import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
  searchKeyword: "",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilter: (state, action) => {
      delete state.filters[action.payload];
    },
    clearAllFilters: (state) => {
      state.filters = {};
    },
    setSearch: (state, action) => {
      state.searchKeyword = action.payload;
    },
  },
});

export const { setFilter, clearFilter, clearAllFilters, setSearch } =
  filterSlice.actions;

export default filterSlice.reducer;
